import type { BucketItemSnapshot } from "./bucket-types";

export const BUCKET_STORAGE_KEY = "mj-bucket:v1";

function getStorage(): Storage | null {
  if (typeof localStorage === "undefined") return null;
  return localStorage;
}

export function readBucket(): BucketItemSnapshot[] {
  const storage = getStorage();
  if (!storage) return [];
  const raw = storage.getItem(BUCKET_STORAGE_KEY);
  if (raw === null) return [];
  try {
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((it): it is BucketItemSnapshot => {
      if (!it || typeof it !== "object") return false;
      const r = it as Partial<BucketItemSnapshot>;
      return typeof r.id === "string" && typeof r.activitySlug === "string";
    });
  } catch {
    return [];
  }
}

export function writeBucket(items: readonly BucketItemSnapshot[]): void {
  const storage = getStorage();
  if (!storage) return;
  storage.setItem(BUCKET_STORAGE_KEY, JSON.stringify(items));
}

export function clearBucket(): void {
  const storage = getStorage();
  if (!storage) return;
  storage.removeItem(BUCKET_STORAGE_KEY);
}
